class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

// Menu nav tab
if(!customElements.get('header-nav-tab')) {
  customElements.define(
    'header-nav-tab',
    class ProductTabs extends HTMLElement {
      constructor() {
        super();

        this.init();
        this.setHeight();
      }
    
      setHeight() {
        const targetElement = Array.from(this.contents).filter(item => item.classList.contains('active'))[0];
        return targetElement.parentElement.style.height = `${targetElement.offsetHeight}px`;
      }
    
      init() {
        this.tabs.forEach(tab => {
          tab.addEventListener('click', (event) => {
            event.preventDefault();
            if(tab.classList.contains('active')) return;
            const target = tab.getAttribute("data-tab-target");
    
            this.resetTabs(this.tabs);
            this.resetTabs(this.contents);
    
            tab.classList.add('active');
            this.querySelector(target).classList.add('active');
            this.querySelector(target).parentElement.style.height = `${this.querySelector(target).offsetHeight}px`;
          });
        });
      }
    
      resetTabs(items) {
        return items.forEach(item => item.classList.remove('active'));
      }

      get tabs() {
        return this.querySelectorAll('[data-tab-target]');
      }

      get contents() {
        return this.querySelectorAll('[data-tab-content]');
      }
    }
  )
}

// Menu open on click
class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);

// Menu open on hover
// class HeaderMenu extends DetailsDisclosure {
//   constructor() {
//     super();
//     this.headerMenu = this.querySelector('details');
//     this.header = document.querySelector('.header-wrapper');
//     this.headerMenuContent = this.headerMenuContent 
//       || this.querySelector('[id^="HeaderMenu-MenuList-"]')
//       || this.querySelector('[id^="MegaMenu-Content-"]');
//   }

//   connectedCallback() {
//     if (!this.closest('header')?.dataset.navOpenHover === 'false') return;

//     this.addEventListeners();
//     this.addDocumentListener();
//     this.addContentListeners();
//   }

//   addEventListeners() {
//     this.headerMenu?.addEventListener('mouseenter', () => {
//       this.closeAllMenus();
//       this.openMenu(this.headerMenu);
//     });

//     Array.from(this.closest('.list-menu')?.children || []).forEach((item) => {
//       item.addEventListener('mouseenter', (event) => {
//         if (!this.parentElement.contains(event.target)) {
//           this.closeMenu(this.headerMenu);
//         }
//       });
//     });
//   }

//   addDocumentListener() {
//     document.addEventListener('mouseover', (event) => {
//       if (!this.header.contains(event.target)) {
//         this.closeMenu(this.headerMenu);
//       }
//     });
//   }

//   addContentListeners() {
//     this.headerMenuContent.querySelectorAll('details')?.forEach((item) => {
//       item.addEventListener('mouseover', () => this.openMenu(item));
//       item.addEventListener('mouseleave', () => this.closeMenu(item));
//     });
//   }

//   openMenu(el) {
//     if (!el.hasAttribute('open')) el.setAttribute('open', '');
//   }

//   closeMenu(el) {
//     if (el.hasAttribute('open')) el.removeAttribute('open', '');
//   }

//   closeAllMenus() {
//     this.header.querySelectorAll('header-menu > details')?.forEach((item) => {
//       this.closeMenu(item);
//     });
//   }

//   onToggle() {
//     if (!this.header) return;
//     this.header.preventHide = this.mainDetailsToggle.open;

//     if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
//     document.documentElement.style.setProperty(
//       '--header-bottom-position-desktop',
//       `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
//     );
//   }
// }

// customElements.define('header-menu', HeaderMenu);
